<template>
  <span :is="tag" :to="to" :class="[baseCss, dense ? `${baseCss}-dense` : null,  'outline-none', 'overflow-hidden', 'm-1', 'select-none', 'cursor-default', block ? ['block'] : ['inline-block', 'align-middle'], setBgColor(), setTextColor(), disabled ? ['disabled', 'pointer-events-none'] : null, `shadow-${elevation}`]" v-if="visible">
    <table-layout y-align="middle" x-align="center">
      <row>
        <cell v-if="icon" :class="['bcq-chip-icon']" :style="{width: dense ? sizeDense : size}">
          <icon :name="icon" :provider="iconProvider" :color="color" :color-lightness="colorLightness" :style="{fontSize: dense ? sizeDense : size}" />
        </cell>
        <cell v-if="avatarSrc || avatarText" :class="['bcq-chip-icon']" :style="{width: dense ? sizeDense : size}">
          <avatar :size="dense ? sizeDense : size" elevation="none" :src="avatarSrc" :text="avatarText" :bg-color="avatarBgColor" :bg-color-lightness="avatarBgColorLightness" :color="avatarColor" :color-lightness="avatarColorLightness" />
        </cell>
        <cell>
          <div :class="['truncate', 'px-1', 'font-semibold']" :style="{lineHeight: dense ? sizeDense : size, fontSize: dense ? '10px' : '12px'}">
            <slot />
          </div>
        </cell>
        <cell @click.native="dismiss" v-if="dismissible" :class="['cursor-pointer', 'bcq-chip-icon']" :style="{width: dense ? sizeDense : size}">
          <icon :provider="iconProvider" name="close-circle" :color="color" :color-lightness="colorLightness" :style="{fontSize: dense ? sizeDense : size}" />
        </cell>
      </row>
    </table-layout>
  </span>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import Utils from '../../mixins/utils'

export default {
  name: 'Chip',
  mixins: [
    props,
    methods
  ],
  model: {
    prop: 'visible',
    event: 'dismiss'
  },
  data () {
    return {
      size: '26px',
      sizeDense: '20px',
      baseCss: this.componentBaseCss('chip', [])
    }
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    dense: {
      type: Boolean
    },
    icon: {
      type: String
    },
    to: {
      type: String
    },
    visible: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    dismissible: {
      type: Boolean
    },
    avatarSrc: {
      type: String
    },
    avatarText: {
      type: String
    },
    avatarBgColor: {
      type: String,
      default: 'gray'
    },
    avatarBgColorLightness: {
      type: [Number, String],
      default: 500,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    avatarColor: {
      type: String,
      default: 'white'
    },
    avatarColorLightness: {
      type: [Number, String],
      default: null,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'black'
    },
    block: {
      type: Boolean
    }
  },
  methods: {
    dismiss (event) {
      this.$emit('dismiss', event.target.value)
    }
  }
}
</script>
<style>
.bcq-chip,
.bcq-chip *
{
  line-height: 1;
}

.bcq-chip
{
  border-radius: 16px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/chip/chip.vue